import React from "react";
import MainBody from "./MainBody";
import SessionTimeoutModal from "./Modals/SessionTimeoutModal";
import "animate.css";

const AppContainer = React.memo((props) => {
  return (
    <>
      <MainBody {...props} />
      <SessionTimeoutModal />
    </>
  );
});

export default AppContainer;
